import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import ErrorModal from "@/components/modals/error.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import Button from "@/components/button.vue"
  import router from "@/router"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'failure',
  setup(__props) {

  const error = ref<Error>(null)
  const orderID = ref<string>(null)

  onBeforeMount(() => {
    orderID.value = useRoute().params.orderID.toString()
  })

  function payRedirect() {
    router.push({
      name: "pay_payment",
      params: {
        orderID: orderID.value
      }
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Failure"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, " Failure ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, " Payment failed, please try again. ", -1)),
          _createVNode(Button, {
            title: "Pay",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (payRedirect()))
          })
        ]),
        _: 1
      }),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})